import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          <Link to="/" className="logo" onClick={closeMobileMenu}>
            <span className="logo-sky">Sky</span>
            <span className="logo-sight">Sight</span>
            <span className="logo-analytics"> Analytics</span>
          </Link>
          
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
          
          <ul className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li><Link to="/why-exit-ready" onClick={closeMobileMenu}>ExitReady™</Link></li>
            <li><Link to="/whats-included" onClick={closeMobileMenu}>ScalePath™</Link></li>
            <li><Link to="/who-its-for" onClick={closeMobileMenu}>Who We Serve</Link></li>
            <li><Link to="/what-we-build" onClick={closeMobileMenu}>Case Studies</Link></li>
            <li><Link to="/contact" className="btn btn-primary" onClick={closeMobileMenu}>Contact Us</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;